import {
  // Views
  Frontpage,
  SubcoverView,
  BlogUnfolded,
  BlogView,
  AnnouncementView,
  GrupMunicipalView,
  CarrecView,
  EquipmentsListing,
  MinisiteView,
  NewsListing,
  EventsListing,
  EquipmentView,
  RouteView,
  GrupsMunicipalsListing,
  EntitiesListing,
  EntityView,
  PublicationsListing,

  // Blocks
  SliderListingBlock,
  IconListingBlock,
  EventsListingBlock,
  NewsListingBlock,
  EquipmentsListingBlock,
  TramitsBlockView,
  TramitsBlockEdit,
  MinisiteInfoView,
  MinisiteInfoEdit,
  OnLiveBlockView,
  OnLiveBlockEdit,
  SocialNetworksBlockView,
  SocialNetworksBlockEdit,
  PublicationsListingBlock,
  LinksListingBlock,
  AgendaBlockView,
  AgendaBlockEdit,
  TramitsListingBlockView,
  TramitsListingBlockEdit,
  CustomHeaderBlockView,
  CustomHeaderBlockEdit,

  // Widgets
  IconSelectorWidget,
  ResultRenderer,
  ColorPicker,
  LeafletWidget,
  LinesWidget,
  RandomCheckboxWidget,
  DatetimeUTCWidget,
  AccordionListingBlock,

  // Controlpanels
  PalafollsControlPanel,

  // Icons
  brandsIconsList,
  ecityclicIconsList,
} from './components';

// Block Icons
import computerSVG from '@plone/volto/icons/computer.svg';
import calendarSVG from '@plone/volto/icons/calendar.svg';
import infoSVG from '@plone/volto/icons/info.svg';
import videoSVG from '@plone/volto/icons/video.svg';
import commentsSVG from '@plone/volto/icons/comment.svg'; 
import zoomSVG from '@plone/volto/icons/zoom.svg'; 

import importTramitsMiddleware from './middleware/importTramits';

import reducers from './reducers'; 

const applyConfig = (config) => {

  // Mutilingual
  // config.settings.isMultilingual = true;
  config.settings.supportedLanguages = ['ca', 'es', 'en'];
  config.settings.defaultLanguage = 'ca';

  // Navigation
  config.settings.navDepth = 2;

  // Opengraph image
  config.settings.contentMetadataTagsImageField = 'preview_image';

  // Hide tags
  config.settings.showTags = false;

  // Map
  config.settings.mapCenter = [41.6673913, 2.7499262]

  //Links
  config.settings.openLinkInNewTab = true;

  // Allow to delete title block
  config.blocks.requiredBlocks = [];

  // Default b_size
  config.settings.defaultPageSize = 30;

  // Reducers
  config.addonReducers = {
    ...config.addonReducers,
    ...reducers,
  };

  // Views
  config.views = {
    ...config.views,
    contentTypesViews: {
      ...config.views.contentTypesViews,
      'Plone Site': Frontpage,
      Announcement: AnnouncementView,
      GrupMunicipal: GrupMunicipalView,
      Carrec: CarrecView,
      Minisite: MinisiteView,
      Equipment: EquipmentView,
      Route: RouteView,
      Entity: EntityView,
    },
    layoutViews: {
      ...config.views.layoutViews,
      blog_unfolded: BlogUnfolded,
      blog_view: BlogView,
      equipments_list_view: EquipmentsListing,
      news_listing_view: NewsListing,
      political_groups_view: GrupsMunicipalsListing,
      events_listing_view: EventsListing,
      entities_listing_view: EntitiesListing,
      publications_listing_view: PublicationsListing,
      subcover_view: SubcoverView,
    },
    layoutViewsNamesMapping: {
      ...config.views.layoutViewsNamesMapping,
      subcover_view: 'Subportada',
      blog_unfolded: 'Blog Desplegada',
      blog_view: 'Blog',
      equipments_list_view: 'Equipaments',
      news_listing_view: 'Notícies',
      events_listing_view: 'Agenda activitats',
      political_groups_view: 'Grups polítics',
      entities_listing_view: 'Entitats i associacions',
      publications_listing_view: 'Publicacions',
    },
  };

  // Blocks
  config.blocks.groupBlocksOrder = [
    ...config.blocks.groupBlocksOrder,
    { id: 'palafolls', title: 'palafolls' },
  ];

  config.blocks.blocksConfig.listing.variations = [
    ...config.blocks.blocksConfig.listing.variations,
    {
      id: 'icon',
      template: IconListingBlock,
      title: 'Icones',
    },
    {
      id: 'slider',
      template: SliderListingBlock,
      title: 'Slides',
    },
    { 
      id: 'events',
      template: EventsListingBlock,
      title: 'Esdeveniments',
    },
    { 
      id: 'news',
      template: NewsListingBlock,
      title: 'Notícies',
    },
    { 
      id: 'equipments',
      template: EquipmentsListingBlock,
      title: 'Equipaments',
    },
    { 
      id: 'pubs',
      template: PublicationsListingBlock,
      title: 'Publicacions',
    },
    { 
      id: 'accordion',
      template: AccordionListingBlock,
      title: 'Acordió',
    },
    { 
      id: 'links',
      template: LinksListingBlock,
      title: 'Enllaços',
    },
  ];
  config.blocks.blocksConfig.listing.showLinkMore = true;

   config.settings.available_colors = [
    '#28334A',
    '#1D273F',
    '#91A6C8',
    '#7BA4DB',
    '#456DBB',
    '#A1C6F3',
    '#E4002B',
    '#EAEAEA',
  ];

  config.blocks.blocksConfig.minisiteinfo = {
    id: "minisiteinfo",
    title: "Minisite Info",
    icon: infoSVG,
    group: "palafolls",
    view: MinisiteInfoView,
    edit: MinisiteInfoEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.tramits = {
    id: "tramits",
    title: "Tramits",
    icon: computerSVG,
    group: "palafolls",
    view: TramitsBlockView,
    edit: TramitsBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.tramitsListing = {
    id: "tramitsListing",
    title: "Llistat tramits",
    icon: zoomSVG,
    group: "palafolls",
    view: TramitsListingBlockView,
    edit: TramitsListingBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agenda = {
    id: "agenda",
    title: "Agenda",
    icon: calendarSVG,
    group: "palafolls",
    view: AgendaBlockView,
    edit: AgendaBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.customHeader = {
    id: "customHeader",
    title: "Custom Header",
    icon: infoSVG,
    group: "palafolls",
    view: CustomHeaderBlockView,
    edit: CustomHeaderBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.gridBlock.allowedBlocks = [
    ...config.blocks.blocksConfig.gridBlock.allowedBlocks,
    'tramits',
  ];
  config.blocks.blocksConfig.gridBlock.blocksConfig = {
    ...config.blocks.blocksConfig,
  };

  config.blocks.blocksConfig.on_live = {
    id: 'on_live',
    title: 'On Live',
    icon: videoSVG,
    group: 'palafolls',
    view: OnLiveBlockView,
    edit: OnLiveBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.social_networks = {
    id: 'social_networks',
    title: 'Social Networks',
    icon: commentsSVG,
    group: 'palafolls',
    view: SocialNetworksBlockView,
    edit: SocialNetworksBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Widgets
  config.widgets.widget.icon_selector = IconSelectorWidget;
  config.widgets.widget.leaflet = LeafletWidget;
  config.widgets.widget.lines_widget = LinesWidget;
  config.widgets.widget.color_widget = ColorPicker;
  config.widgets.widget.random_checkbox_widget = RandomCheckboxWidget
  config.widgets.widget.datetime_utc = DatetimeUTCWidget;

  config.widgets = {
    ...config.widgets,
    id: {
      ...config.widgets.id,
      content_icon: IconSelectorWidget,
      content_color: ColorPicker,
      geolocation: LeafletWidget,
      effective: DatetimeUTCWidget,
      expires: DatetimeUTCWidget,
    },
  };

  // Icon Selector
  config.settings.widget.icon_selector = {
    ...config.settings.widget.icon_selector,
    iconList: {
      ...config.settings.widget.icon_selector.iconList,
      ecityclic: ecityclicIconsList,
      brands: brandsIconsList,
    },
    defaultRenderer: {
      ...config.settings.widget.icon_selector.defaultRenderer,
      ResultRenderer
    }
  }

  // Controlpanels
  config.addonRoutes = [
    ...config.addonRoutes,
    {
      path: '/controlpanel/palafolls-controlpanel',
      component: PalafollsControlPanel,
    },
  ];

  config.settings.apiExpanders = [
    ...config.settings.apiExpanders,
    {
      match: '',
      GET_CONTENT: ['header_info'],
    },
  ];

  if (__SERVER__) {
    const express = require('express');
    const brevoMiddleware = require('./middleware/brevo');
    config.settings.expressMiddleware = [
      ...(config.settings.expressMiddleware || []),
      importTramitsMiddleware(express),
      brevoMiddleware(),
    ];
  }

  return config;
};

export default applyConfig;
